import { Card, Col, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingProduct } from "../../../components";
import { AddDataJacket, getDataJacketById, updateDataJacket } from "../../../config/Redux/action";
import { ActionProduct } from "../../../config/Redux/actionTypes";

const JacketForm = () => {
  const intialInput = {
  name: '',
  kind: '',
  stock: 0,
  price: 0,
  promoPrice: 0,
  image_url: '',
  desc: '',
  s: false,
  m: false,
  l: false,
  xl: false,
  xxl: false,
  publish: 'notPublished',
  shopee: '',
  lazada: '',
  tokopedia: '',
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {Id} = useParams();
  console.log(Id);
  const product = useSelector((state) => state.product)
  const [input, setInput] = useState(intialInput);
  const idBenefit = Math.random() * 10;
  const [benefit, setBenefit] = useState([
    {
      id: idBenefit,
      benefit: '',
    },
  ]);

  const getDatabyId = async (id) => {
    try {
      const trouser = await getDataJacketById(id);
      setInput({
        name: trouser.name,
        kind: trouser.kind,
        stock: trouser.stock,
        price: trouser.price,
        promoPrice: trouser.promoPrice,
        shopee: trouser.shopee,
        tokopedia: trouser.tokopedia,
        lazada: trouser.lazada,
        image_url: trouser.image_url,
        desc: trouser.desc,
        publish: trouser.publish,
        s: trouser.size.S,
        m: trouser.size.M,
        l: trouser.size.L,
        xl: trouser.size.XL,
        xxl: trouser.size.XXL,
      });
      setBenefit(trouser.benefit.map((res) => res));
    } catch (err) {
      message.error(err.message);
    }
  };

  useEffect(() => {
    if (Id !== undefined) {
      getDatabyId(Id);
    }
    if (product.successCreate === true) {
      navigate('/dashboard/jacket');
      message.success('Data Berhasil Ditambahkan', [3]);
      dispatch({ type: ActionProduct.SUCCESS_CREATE, value: false });
    } else if (product.successUpdate === true) {
      navigate('/dashboard/jacket');
      message.success('Data Berhasil Diubah', [3]);
      dispatch({ type: ActionProduct.SUCCESS_UPDATE, value: false });
    }
    return () => {
      setInput(intialInput);
      setBenefit([{ id: '', benefit: '' }]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, navigate, product]);

  const handleOnChange = (e) => {
      const {name, value} = e.target;
      const size = ['s', 'm', 'l', 'xl', 'xxl'];
      if(size.indexOf(name) < 0){
          setInput({...input, [name] : value});
      }else{
          setInput({...input, [name] : !input[name] });
      }
  }
  const handleChangeBenefit = (id, e) => {
    let { name, value } = e.target;
    const newBenefit = benefit.map((i) => {
      if (id === i.id) {
        i[name] = value;
      }
      return i;
    });

    setBenefit(newBenefit);
  };

  const handleAddBenefit = (e) => {
    e.preventDefault();
    setBenefit([...benefit, { id: idBenefit, benefit: '' }]);
  };
  const handleSubmit =(e) => {
    e.preventDefault();
    const {
      name,
      kind,
      stock,
      price,
      promoPrice,
      s,
      l,
      m,
      xl,
      xxl,
      image_url,
      publish,
      desc,
      shopee,
      lazada,
      tokopedia,
    } = input;
    const size = {
      S: s,
      M: m,
      L: l,
      XL: xl,
      XXL: xxl,
    };

    const res = {
      name,
      kind,
      stock,
      price,
      promoPrice,
      size,
      image_url,
      publish,
      desc,
      shopee,
      lazada,
      tokopedia,
      benefit,
    };

    if (Id !== undefined) {
      dispatch(updateDataJacket(Id, res));
    } else {
      dispatch(AddDataJacket(res));
    }
    setInput(intialInput);
    setBenefit([{ id: '', benefit: '' }]);
  }

  return (
    <div className='form-product site-card-border-less-wrapper'>
      <Card
        className='card'
        title={<h1>Form Jacket</h1>}
        bordered={true}
        style={{ width: '100%' }}
      >
        <div>
          <form onSubmit={handleSubmit}>
            <Row gutter={32}>
              <Col span={12}>
                <div>
                  <label>Name Product</label>
                  <input
                    required
                    type='text'
                    name='name'
                    value={input.name}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label>Kind</label>
                  <input
                    required
                    type='text'
                    name='kind'
                    value={input.kind}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col span={12}>
                <div>
                  <label>Stock</label>
                  <input
                    required
                    type='number'
                    name='stock'
                    value={input.stock}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label>Price</label>
                  <input
                    required
                    type='number'
                    name='price'
                    value={input.price}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col span={12}>
                <div>
                  <label>Promo Price</label>
                  <input
                    required
                    type='number'
                    name='promoPrice'
                    value={input.promoPrice}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label>Link Shopee</label>
                  <input
                    required
                    type='text'
                    name='shopee'
                    value={input.shopee}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col span={12}>
                <div>
                  <label>Link Tokopedia</label>
                  <input
                    required
                    type='text'
                    name='tokopedia'
                    value={input.tokopedia}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label>Link Lazada</label>
                  <input
                    required
                    type='text'
                    name='lazada'
                    value={input.lazada}
                    onChange={handleOnChange}
                  />
                </div>
              </Col>
            </Row>
            <div>
              <label>cover</label>
              <input
                required
                type='text'
                name='image_url'
                value={input.image_url}
                onChange={handleOnChange}
              />
            </div>
            <div>
              <label>Description</label>
              <textarea
                required
                type='text'
                name='desc'
                value={input.desc}
                onChange={handleOnChange}
                rows={10}
              />
            </div>
            <Row>
              <Col span={12}>
                <div>
                  <label style={{ fontSize: '18px' }}>Size</label>
                  <br />
                  <div
                    style={{
                      display: 'flex',
                      marginTop: '4px',
                      marginBottom: '12px',
                    }}
                  >
                    <input
                      type='checkbox'
                      name='s'
                      checked={input.s}
                      onChange={handleOnChange}
                    />
                    <label className='labelCheckbox'>S</label>
                    <br />
                    <input
                      type='checkbox'
                      name='m'
                      checked={input.m}
                      onChange={handleOnChange}
                    />
                    <label className='labelCheckbox'>M</label>
                    <input
                      type='checkbox'
                      name='l'
                      checked={input.l}
                      onChange={handleOnChange}
                    />
                    <label className='labelCheckbox'>L </label>
                    <input
                      type='checkbox'
                      name='xl'
                      checked={input.xl}
                      onChange={handleOnChange}
                    />
                    <label className='labelCheckbox'>XL</label>
                    <input
                      type='checkbox'
                      name='xxl'
                      checked={input.xxl}
                      onChange={handleOnChange}
                    />
                    <label className='labelCheckbox'>XXL</label>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label style={{ fontSize: '18px' }}>Published</label>
                  <br />
                  <div style={{ display: 'flex' }}>
                    <input
                      type='radio'
                      id='publish'
                      name='publish'
                      value={'published'}
                      checked={input.publish === 'published'}
                      onChange={handleOnChange}
                    />
                    <label
                      style={{
                        fontSize: '16px',
                        fontWeight: '400',
                        marginLeft: '4px',
                        marginRight: '12px',
                      }}
                    >
                      Yes
                    </label>
                    <br />
                    <input
                      type='radio'
                      id='publish'
                      name='publish'
                      value={'notPublished'}
                      checked={input.publish === 'notPublished'}
                      onChange={handleOnChange}
                    />
                    <label
                      style={{
                        fontSize: '16px',
                        fontWeight: '400',
                        marginLeft: '4px',
                      }}
                    >
                      No
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
            <div>
              <label>Benefit</label>
              {benefit.map((field, index) => (
                <div key={index} className='benefit-form'>
                  <input
                    name='benefit'
                    type={'text'}
                    placeholder='Input benefit'
                    className='input-skill'
                    value={field.benefit}
                    onChange={(event) => handleChangeBenefit(field.id, event)}
                  />
                  <button onClick={handleAddBenefit} className='another_skill'>
                    +
                  </button>
                </div>
              ))}
            </div>
            {product.isLoading ? (
              <LoadingProduct />
            ) : (
              <input style={{ marginTop: '30px' }} type='submit' value='Save' />
            )}
          </form>
        </div>
      </Card>
    </div>
  );
};
export default JacketForm